import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import defaultUser from 'assets/images/avatar.svg';
import plusImg from "../../assets/images/plusImg.png"
import { authService, userService } from 'services';
import useCurrentUser from 'hooks/useCurrentUser';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SwitchAccount = (props) => {
    const navigate = useNavigate()
    const { show, handleClose } = props;
    const [data, setData] = useState([]);
    const { user } = useCurrentUser()
    const token = localStorage.getItem('token');
    const { setToken, user: currentUser, loading } = useCurrentUser();

    const switchProfile = async () => {

        try {
            const response = await authService.switchProfile();
            if (response?.data?.data?.token) {
                navigate('/dashboard');
                toast.success(response.data.data.message);
                localStorage.setItem("token", response.data.data.token);
                setToken(response.data.data.token);
            } else {
                toast.error(response.data.data.message);
            }
        } catch (err) {
            console.log(err?.response?.data?.data)
        }
    }


    const getRoleList = async () => {
        try {
            const response = await userService.getRole();
            setData(response?.data?.data)
        }
        catch (err) {
            console.log(err?.response?.data?.data)
        }
    }


    function toSentenceCase(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    useEffect(() => {
        getRoleList()
    }, [])
    return (
        <>
            <Modal show={show} className="modal-common" onHide={handleClose}>
                <Modal.Header closeButton>Switch Account</Modal.Header>
                <Modal.Body style={{ padding: '15px 20px' }}>
                    <div className=''>
                        {data?.map((item, i) => {
                            return (<div key={item?.roleType} className='account-card d-flex align-items-center gap-4 justify-content-between py-2 my-1'>
                                <div className='d-flex gap-4 '>
                                    <div>
                                        <img
                                            src={`${user?.baseS3Url}${item?.avatar || ""}`}
                                            alt="User Avatar"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                            }}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null; // prevent infinite loop
                                                e.currentTarget.src = defaultUser; // fallback image
                                            }}
                                        />

                                    </div>
                                    <div>
                                        <h6>{toSentenceCase(item?.roleType)} Profile</h6>
                                        <h6>{item?.fullName}</h6>
                                    </div>
                                </div>
                                <div>
                                    {item?.roleType === user?.roleType ? <button className='px-4 py-2 text-blue' style={{ backgroundColor: '#e9f0f6', border: '0', borderRadius: '24px' }}>Active</button> : <button className='px-4 py-2 text-blue' style={{ backgroundColor: '#e9f0f6', border: '0', borderRadius: '24px' }} onClick={switchProfile}>Switch</button>}
                                </div>
                            </div>)
                        })}

                        {data?.length === 1 &&
                            <div className='d-flex align-items-center gap-4 justify-content-between add-account'>
                                <div className='d-flex gap-4 cursor-pointer'>
                                    <div>
                                        <img src={plusImg} alt="" className='w-full p-3' style={{ backgroundColor: '#e9f0f6', border: '0', borderRadius: '24px' }} />
                                    </div>
                                    <div>
                                        <h6>Don’t have an user account</h6>
                                        <h5 onClick={switchProfile}>Create an account</h5>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SwitchAccount
